// extracted by mini-css-extract-plugin
export default {"apiInput":"index-module__YwfHL","apiBox":"index-module__TfpR4","copySpan":"index-module__I4gx7","apiLabel":"index-module___0vhE","apiOuter":"index-module__DKH5Z"};